module.exports = __webpack_public_path__ + "static/img/sad_green.f77ae496.png";